import React from 'react';
import { MdVideoLibrary } from 'react-icons/md'
import { LinkContainer } from 'react-router-bootstrap';

import './albumCard.css';

const AlbumCard = props => {

    const { title, cover, href, video } = props;

    return (
        <LinkContainer to={href}>
            <a className="album-card">
                <div className="album-cover-wrap">
                    {!!video && <MdVideoLibrary className="video-icon" />}
                    <img className="img-fluid img-thumbnail" src={cover} alt={title + " cover"} />
                </div>
                <h4 className="album-title text-center">{title}</h4>
            </a>
        </LinkContainer>
    )
}

export default AlbumCard;